import { defineStore } from 'pinia';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import { useProjectStore } from './projectStore';

export const useContactStore = defineStore('contact', {
  state: () => ({
    contacts: [],
    contactsLoading: false,
    contactLoading: false,
  }),

  actions: {
    async postContact(formData: FormData) {
      this.contactLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.postContact(projectStore.projectIdSelected, formData);
        notificationWrapper('success', 'POST_CONTACT');
        this.contacts = data.tickets;
        this.contactLoading = false;
        return true;
      } catch (error) {
        this.contactLoading = false;
        if (error && (error.status === 413 || error.status === 400)) {
          notificationWrapper('error', error.status === 413
            ? 'EMAIL_SUPPORT_FILES_TOO_BIG' : 'DEFAULT');
          return false;
        }
        notificationWrapper();
        throw error;
      }
    },

    async getContacts() {
      this.contactsLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getContacts(projectStore.projectIdSelected);
        this.contacts = data.tickets;
        this.contactsLoading = false;
      } catch (error) {
        notificationWrapper();
        this.contactsLoading = false;
      }
    },
  },
});
